// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
// Constants for the hotspot components.
import { HotspotItemDTO } from '@shared/models/dashboard/hotspot-item';
export const hotspotTestDto1: HotspotItemDTO = {
    orderId: 1,
    order: 'ord1',
    customerId: 1,
    customer: 'cust1',
    assets: {
      standing: '4',
      normalCount: 1,
      warningCount: 1,
      criticalCount: 1,
      overdueCount: 1,
    },
    scheduled: {
      standing: '5',
      normalCount: 2,
      warningCount: 1,
      criticalCount: 1,
      overdueCount: 1,
    },
    collected: {
      standing: '6',
      normalCount: 3,
      warningCount: 1,
      criticalCount: 1,
      overdueCount: 1,
    },
    processed: {
      standing: '7',
      normalCount: 4,
      warningCount: 1,
      criticalCount: 1,
      overdueCount: 1,
    },
    delivered: {
      standing: '8',
      normalCount: 5,
      warningCount: 1,
      criticalCount: 1,
      overdueCount: 1,
    },
    dueDate: '2021-03-02',
    statusSummaryString: 'Assets 1 1 1 1 Scheduled 2 1 1 1 Collected 3 1 1 1 Processed 4 1 1 1 Delivered 5 1 1 1',
  };

  export const hotspotTestDto2: HotspotItemDTO = {
    orderId: 2,
    order: 'ord2',
    customerId: 24,
    customer: 'cust2',
    assets: {
      standing: '10',
      normalCount: 1,
      warningCount: 2,
      criticalCount: 3,
      overdueCount: 4,
    },
    scheduled: {
      standing: '18',
      normalCount: 5,
      warningCount: 6,
      criticalCount: 7,
      overdueCount: 0,
    },
    collected: {
      standing: '15',
      normalCount: 9,
      warningCount: 1,
      criticalCount: 2,
      overdueCount: 3,
    },
    processed: {
      standing: '22',
      normalCount: 4,
      warningCount: 5,
      criticalCount: 6,
      overdueCount: 7,
    },
    delivered: {
      standing: '20',
      normalCount: 8,
      warningCount: 9,
      criticalCount: 1,
      overdueCount: 2,
    },
    dueDate: '2021-02-28',
    statusSummaryString: 'Assets 10 10 10 10 Scheduled 1 2 3 4 Collected 1 2 3 4 Processed 1 2 3 4 Delivered 1 2 3 4',
  };